var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item){return _c('li',{key:item.link,staticClass:"breadcrumb-item"},[(item.link)?_c('router-link',{attrs:{"to":item.link}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")]):_c('span',[_vm._v(_vm._s(item.name))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21686e98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/user/partials/breadCrumb/index.vue
// module id = null
// module chunks = 